import { render, staticRenderFns } from "./IPViewEmailKelistrikan.vue?vue&type=template&id=16380bfb&scoped=true&lang=pug&"
import script from "./IPViewEmailKelistrikan.vue?vue&type=script&lang=js&"
export * from "./IPViewEmailKelistrikan.vue?vue&type=script&lang=js&"
import style0 from "./IPViewEmailKelistrikan.vue?vue&type=style&index=0&id=16380bfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16380bfb",
  null
  
)

export default component.exports